import React from "react";
import { Layout, Breadcrumb, Card, Menu } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { routesClientData, baseClientPath } from "../../routes";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;


const ClientLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const onLink = (path) => {
    navigate(path);
  };
  console.log("location", location.pathname);
  const newRouters = [];
  routesClientData.forEach((item) => {
    if (!item.children) {
      newRouters.push({
        ...item,
        path: `/${baseClientPath}/${item.path}`,
      });
    } else {
      item.children.forEach((ele) => {
        newRouters.push({
          ...ele,
          path: `/${baseClientPath}/${item.path}/${ele.path}`,
        });
      });
    }
  });
  const currentRouter = newRouters.find(
    (item) => item.path === location.pathname
  );
  return (
    <>
      <Sider width={100} className="layout-sider">
        <Menu
          mode="inline"
          defaultSelectedKeys={[currentRouter.path]}
          defaultOpenKeys={[currentRouter.path]}
          style={{ height: "100%", borderRight: 0 }}
        >
          {routesClientData.map((ele) => {
            if (ele.children) {
              return (
                <SubMenu
                  key={ele.title}
                  icon={<UserOutlined />}
                  title={ele.title}
                >
                  {ele.children.map((item) => {
                    const path = `/${baseClientPath}/${ele.path}/${item.path}`;
                    return (
                      <Menu.Item key={path} onClick={onLink.bind(this, path)}>
                        {item.title}
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              );
            } else {
              const path = `/${baseClientPath}/${ele.path}`;
              return (
                <Menu.Item key={path} onClick={onLink.bind(this, path)}>
                  {ele.title}
                </Menu.Item>
              );
            }
          })}
        </Menu>
      </Sider>
      <Layout className="layout-container">
        {currentRouter && currentRouter.breadcrumb && (
          <Breadcrumb style={{ marginTop: 6 }}>
            {currentRouter.breadcrumb.map((ele) => (
              <Breadcrumb.Item key={ele.title}>{ele.title}</Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
        <Content>
          <Card className="layout-container-card">
            <Outlet />
          </Card>
        </Content>
      </Layout>
    </>
  );
};

export default ClientLayout;
